import React from "react";
import { Avatar, Badge } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const CustomAvatar = ({
  userName = "",
  img,
  size = 60,
  isServerImage = true,
  allowBadge = false,
  badgeFunction = () => {},
  reRenderDisableOnText = false,
}) => {
  // Helper to get the initial from the username
  const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : "?");

  // Helper to construct the server image URL
  const createImageURL = (pathname) =>
    `${"https://e-connect.elsner.com/public"}/${pathname}`;

  // Determine if the image is valid
  const imageSrc = img ? (isServerImage ? createImageURL(img) : img) : null;
  // Fallback to initials if no valid image
  const isImageValid = Boolean(img);

  return (
    <Badge
      className="avatar-img"
      onClick={() => badgeFunction()}
      count={
        <CloseCircleOutlined
          style={{
            color: "#f5222d",
            display: allowBadge && img ? "" : "none",
          }}
        />
      }
    >
      {!reRenderDisableOnText && (
        <Avatar
          key={userName}
          src={isImageValid ? imageSrc : undefined} // Only pass src if the image is valid
          alt={userName}
          size={size}
          sx={{
            fontSize: size / 2,
            backgroundColor: !isImageValid ? "#ccc" : "transparent",
          }}
        >
          {!isImageValid && getInitial(userName)}
        </Avatar>
      )}

      {reRenderDisableOnText && (
        <div className="custom-avatar">{getInitial(userName)}</div>
      )}
    </Badge>
  );
};

// Memoize the component with a custom comparison function
export default React.memo(CustomAvatar, (prevProps, nextProps) => {
  // Compare props to prevent unnecessary re-renders
  return (
    prevProps.img === nextProps.img &&
    prevProps.userName === nextProps.userName &&
    prevProps.size === nextProps.size &&
    prevProps.isServerImage === nextProps.isServerImage &&
    prevProps.allowBadge === nextProps.allowBadge &&
    prevProps.customInitial === nextProps.customInitial
  );
});
